import styled from "styled-components";

export const VisuallyHiddenUploadInput = styled.input`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  white-space: nowrap;
  width: 1;
`;

export const ImageApproveContainer = styled.div`
  display: flex;
  align-self: center;
  flex-direction: column;
  img {
    width: 150px;
  }
  button {
    position: absolute;
    margin: none;
    padding: none;
    color: white;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 0px;
    width: 150px;
    height: 25px;
  }
`;